<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Example ledger</div>

          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="message" class="alert alert-success">{{ message }}</div>
            <br>
            <b>Financial planning is easier said than done?</b><br>
            <br>
            <b>Not feeling very inspired when it comes to listing all your possible future expenses?</b><br>
            <br>
            <b>Having too many Unexpected Expenses</b>, that could have been predicted better, if you just remembered to put them on the list?<br>
            <i>(I’m not saying you can predict everything! Sometimes, your car simply breaks down, or your pet needs
            a sudden visit to the vet. But maybe, just maybe, some of these expenses, like your annual vehicle
            inspection for example, are actually quite predictable if you simply don't forget about their existence.)</i>
            <br>
            <br>
            If you answered “yes” to any of the above, then I believe this Example Ledger might help. It contains a
            wide range of possible expense types—from house-related, to special events in your life, to personal
            grooming—with the sole purpose of bringing to your attention some of the most common expenses many
            of us have.<br>
            <br>
            It’s not a complete list, but it’s a great start that can make your planning easier and more efficient.
            Just hit Create, and play with the ledger to customize it to your own needs! Enjoy!
            <br>
            <br>
            <div class="form-group row mb-0">
              <div class="col-12 text-center">
                <button type="submit" class="btn btn-primary" @click.prevent="submit()">
                  <span v-if="this.$loading.isLoading('ledger-example-creating')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Create example ledger
                </button>
              </div>
            </div>
            <br>
            <br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ExampleLedger',
  data () {
    return {
      error: '',
      errors: {},
      message: ''
    }
  },
  methods: {
    ...mapActions([
      'createExampleLedger'
    ]),
    submit () {
      this.$loading.startLoading('ledger-example-creating')
      this.errors = {}
      this.createExampleLedger()
        .then((data) => {
          this.$loading.endLoading('ledger-example-creating')
          this.error = ''
          this.errors = {}
          this.message = data.message
          this.$router.push({ name: 'Ledger', params: { id: data.ledger.id } })
        })
        .catch((data) => {
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('ledger-example-creating')
        })
    }
  }
}
</script>
